/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function DataConsumption(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M3 8.00023H21H3ZM7.5 17.0002V15.5202V17.0002ZM10.5 17.0002V12.2502V17.0002ZM13.5 17.0002V14.9302V17.0002ZM16.5 17.0002V12.8002V17.0002ZM10.866 5.49523C10.863 5.49523 10.861 5.49723 10.861 5.50023C10.861 5.50323 10.863 5.50523 10.866 5.50523C10.869 5.50523 10.871 5.50323 10.871 5.50023C10.871 5.49723 10.869 5.49523 10.866 5.49523ZM8.327 5.49523C8.324 5.49523 8.322 5.49723 8.322 5.50023C8.322 5.50323 8.324 5.50523 8.327 5.50523C8.33 5.50523 8.332 5.50323 8.332 5.50023C8.332 5.49723 8.33 5.49523 8.327 5.49523ZM5.779 5.49023C5.776 5.49023 5.774 5.49223 5.774 5.49523C5.774 5.49823 5.776 5.50023 5.779 5.50023C5.782 5.50023 5.784 5.49823 5.784 5.49523C5.784 5.49223 5.782 5.49023 5.779 5.49023Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

DataConsumption.defaultProps = {
  color: "current",
  size: 24,
};

DataConsumption.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
